//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        mobile: {
            type: String,
            required: true,
            default: "",
        },
    },
    watch: {
        show() {
            this.showPopup = this.show;
        },
    },
    data() {
        return {
            showPopup: this.show,
            codes: ["", "", "", "", "", ""],
            time: 60,
            timer: null,
        };
    },
    methods: {
        onDelete() {
            const idx = this.codes.indexOf("");
            this.codes.splice(
                idx === -1 ? this.codes.length - 1 : idx - 1,
                1,
                ""
            );
        },
        onInput(key) {
            const idx = this.codes.indexOf("");
            if (idx !== -1) {
                this.codes.splice(this.codes.indexOf(""), 1, key);
            }
            if (this.codes.every((val) => val !== "")) {
                this.$emit("callback", this.codes.join(""));
            }
        },
        startTimer(isResend) {
            if (isResend) {
                this.$emit("send-vertification-code");
            }
            this.time = 60;
            this.timer = setInterval(() => {
                this.time--;
                if (this.time === 0) {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        clearTimer() {
            this.time = 0;
            clearInterval(this.timer);
        },
    },
    filters: {
        encryptMobile(mobile) {
            return mobile.slice(0, 3) + "*****" + mobile.slice(8);
        },
    },
    mounted() {
        this.$bus.$on("validate-code-error", () => {
            this.clearTimer();
            this.codes = ["", "", "", "", "", ""];
        });

        this.$nextTick(() => {
            this.startTimer();
        });
        this.sensorsRecord("h5_element_imp", {
            tgt_event_id: "h5_paycash_sendvercode_show",
            tgt_name: "h5-paycash-展示发送验证码组件",
            url: location.href,
            page: "验证码组件",
        });
    },
    destroyed() {
        clearInterval(this.timer);
        this.$bus.$off(["validate-code-error"]);
    },
};
